/**
 * Created by Jerker Nord on 2019-01-09.
 */
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IScreenConfig} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {FreespinOutroController} from "@nolimitcity/slot-game/bin/game/screen/freespinoutro/FreespinOutroController";
import {ThorGameMode} from "../../gamemode/ThorGameMode";
import {ThorGameModuleConfig} from "../../ThorGameModuleConfig";

export class ThorFreeSpinOutroController extends FreespinOutroController {

    constructor(config:IScreenConfig) {
        super(config);
    }

    protected calculateIsTriggered(data:ParsedServerData):boolean {
        if(data.freespinsLeft == 0 && data.mode == GameMode.FREESPIN && data.nextMode == GameMode.NORMAL) {
            return true;
        } else if(data.freespinsLeft == 0 && data.mode == ThorGameMode.NUDGE_RESPIN_FS && data.nextMode == GameMode.NORMAL) {
            return true;
        } else {
            return false;
        }
    }

    public static actuallyDoTransition() {
        ThorGameModuleConfig.thorExtraFSIconView.hideExtraFSIconTL();
        ThorGameModuleConfig.thorFreeSpinBoxView.resetFreeSpinBoxFSEnd();
        EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {newMode : ThorGameMode.NORMAL}));
    }
}